import React from 'react';
import clsx from 'clsx';
import Button from '@mui/material/Button';

import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ArrowBackIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIcon from '@mui/icons-material/ArrowForwardIos';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from './ViewerCarousel.styles';
import theme from '../../../../styles/theme';

interface ViewerCarouselProps {
  files: { id: string; url: string; type: string; name: string }[];
  selectedFileIndex: number;
  onClose: () => void;
  onNextClick: () => void;
  onPreviousClick: () => void;
  onDownloadClick: () => void;
  onZoomClick: (zoomFactor: number) => void;
  children: React.ReactNode;
  isImage?: boolean;
}

const ViewerCarousel = React.forwardRef<HTMLDivElement, ViewerCarouselProps>(
  (props, ref) => {
    const {
      files,
      selectedFileIndex,
      onClose,
      onNextClick,
      onPreviousClick,
      onDownloadClick,
      children,
      onZoomClick,
      isImage = false,
    } = props;

    const { classes } = useStyles(theme);

    return (
      <div className={classes.viewCarouselWrapper} ref={ref}>
        <Button
          className={clsx(classes.panelButton, classes.closeButton)}
          onClick={onClose}>
          <CloseIcon />
        </Button>
        <div className={classes.mainContent}>{children}</div>

        <div className={classes.bottomPanel}>
          <Button
            className={clsx(classes.panelButton, !isImage && 'disabled')}
            disabled={!isImage}
            onClick={() => onZoomClick(2)}>
            <ZoomInIcon />
          </Button>
          <Button
            className={clsx(classes.panelButton, !isImage && 'disabled')}
            disabled={!isImage}
            onClick={() => onZoomClick(0.5)}>
            <ZoomOutIcon />
          </Button>
          <Button className={classes.panelButton} onClick={onPreviousClick}>
            <ArrowBackIcon />
          </Button>
          <div className={classes.countInfo}>
            {selectedFileIndex + 1}/{files.length}
          </div>

          <Button className={classes.panelButton} onClick={onNextClick}>
            <ArrowForwardIcon />
          </Button>
          <Button
            className={clsx(classes.panelButton, classes.downloadButton)}
            onClick={onDownloadClick}>
            <DownloadIcon /> Download
          </Button>
        </div>
      </div>
    );
  },
);

export default ViewerCarousel;
